import { render, staticRenderFns } from "./PatientCreated.vue?vue&type=template&id=3eda334a"
import script from "./PatientCreated.vue?vue&type=script&lang=js"
export * from "./PatientCreated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports